import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { MainSubHeaderContainer } from 'src/components/subheader/SubHeader.style';
import SubheaderItem from 'src/components/subheader/SubheaderItem';
import { browseByTypeAPICall } from 'src/services/apiRequests/TvShowDetailsPage/GenreLanguageService';
import { PAGE_NAME_CONSTANTS } from 'src/utils/constants/ConsumptionPagesConstants';
import {
  SubheaderProps,
  BrowseItemsType
} from 'src/utils/constants/TvShowDetailsPageConstants';
import { genreLanguageLink } from 'src/utils/TvShowDetailsHelper/tvShowDetailsHandler';

const SubHeader = (props: SubheaderProps) => {
  const {
    browseByType,
    assetSubType,
    isAllRequired,
    contentName,
    contentId,
    subHeaderItems
  } = props;
  const [subHeaderMenuItems, setSubHeaderMenuItems] =
    useState<[BrowseItemsType]>(subHeaderItems);
  const router = useRouter();

  useEffect(() => {
    if (!(subHeaderMenuItems && subHeaderMenuItems.length)) {
      updateDisplayData();
    }
  }, []);

  const updateDisplayData = async () => {
    const subHeaderItems = await browseByTypeAPICall(
      assetSubType,
      browseByType,
      !!isAllRequired
    );
    if (subHeaderItems.length) {
      setSubHeaderMenuItems(subHeaderItems as [BrowseItemsType]);
    }
  };
  const genreLanguageClick = (item: string) => {
    const url = genreLanguageLink(item, router);
    if (url && url.length) {
      window.location.href = url;
    }
  };

  return (
    <MainSubHeaderContainer data-testid="submenuHeaderMainDiv">
      {subHeaderMenuItems?.map((menuItem: BrowseItemsType, index: number) => {
        return (
          <div key={index} data-testid={`submenuSubDiv-${index}`}>
            <SubheaderItem
              data-testid={`submenuSubContainerDiv-${index}`}
              data={menuItem}
              genreLanguageClick={genreLanguageClick}
              horizontalIndex={index + 1}
              contentName={contentName}
              contentId={contentId}
              pageName={PAGE_NAME_CONSTANTS.SHOW_LANDING}
            />
          </div>
        );
      })}
    </MainSubHeaderContainer>
  );
};

export default SubHeader;
